import { apiFetch } from './client'
import { ApiError } from './errors'

/**
 * s69 / 2x (Marcelo 29/10/2026 17:25, "preciso criar no meu usuario a possibilidade de criar la esse usuario master da
 * empresa"; 17:28 "2x sim ; papeis 3"): a tela de Usuarios sobre as rotas /api/iam/users que ja existiam (ADR-0030).
 *
 * TRAVA do erro E11-s69 (o script 91 criou o Andre na empresa ERRADA por nao mandar a empresa): TODA chamada leva o
 * `tenant_id` da empresa em que se esta trabalhando, explicito -- nunca o "padrao do servidor".
 * TRAVA do login: a empresa de quem entra sai do DOMINIO do e-mail; e-mail fora do dominio da empresa nao entra. A tela
 * recusa antes de mandar (`dominioAceito`).
 * Os 3 papeis (decisao "papeis 3"); papeis montados por empresa = ADR de perfis (Q1), depois.
 */
export interface IamUser {
  id: string
  tenantId: string
  username: string
  email: string
  isActive: boolean
  roleNames: string[]
  passwordChangeRequired: boolean
}

interface UserResp {
  id: string
  tenant_id: string
  username: string
  email: string
  is_active: boolean
  role_names?: string[]
  password_change_required: boolean
}

export const PAPEIS = [
  { name: 'tenant_admin', label: 'Administrador da empresa' },
  { name: 'hr_manager', label: 'RH' },
  { name: 'diretoria', label: 'Diretoria' },
] as const

export const USERS_QUERY_KEY = (tenantId: string) => ['iam-users', tenantId] as const
export const USERS_PERMISSION = 'iam.user.list'
export const USERS_CREATE_PERMISSION = 'iam.user.create'

const de = (u: UserResp): IamUser => ({
  id: u.id,
  tenantId: u.tenant_id,
  username: u.username,
  email: u.email,
  isActive: u.is_active,
  roleNames: u.role_names ?? [],
  passwordChangeRequired: u.password_change_required,
})

export async function fetchUsers(tenantId: string): Promise<IamUser[]> {
  const r = await apiFetch<{ users: UserResp[] }>(
    `/api/iam/users?tenant_id=${encodeURIComponent(tenantId)}&include_inactive=true&limit=500`,
  )
  return (r.users ?? []).map(de)
}

export async function createUser(n: {
  tenantId: string
  username: string
  email: string
  password: string
  roleNames: string[]
}): Promise<IamUser> {
  const r = await apiFetch<UserResp>('/api/iam/users', {
    method: 'POST',
    body: { username: n.username, email: n.email, password: n.password, tenant_id: n.tenantId, role_names: n.roleNames },
  })
  return de(r)
}

export async function setUserActive(id: string, ativo: boolean): Promise<IamUser> {
  const r = await apiFetch<UserResp>(`/api/iam/users/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: { is_active: ativo },
  })
  return de(r)
}

/** Dominios ATIVOS da empresa (so o administrador da plataforma le; para o cliente, 403 -> null). */
export async function fetchDomains(tenantId: string): Promise<string[] | null> {
  try {
    const r = await apiFetch<{ email_domain: string; is_active: boolean }[]>(
      `/api/tenants/${encodeURIComponent(tenantId)}/email-domains`,
    )
    return r.filter((d) => d.is_active).map((d) => d.email_domain.toLowerCase())
  } catch (e) {
    if (e instanceof ApiError && (e.status === 403 || e.status === 404)) return null
    throw e
  }
}

/** Dominio do e-mail (minusculo), ou '' se nao e e-mail. */
export function dominio(email: string): string {
  const e = email.trim().toLowerCase()
  const i = e.lastIndexOf('@')
  return i > 0 && i < e.length - 1 ? e.slice(i + 1) : ''
}

/**
 * Dominios aceitos para o e-mail novo: os da empresa (quando a API os da) ou, para o administrador do cliente (que
 * nao le dominios), o do PROPRIO e-mail dele -- ele so cria gente da empresa dele.
 */
export function dominiosAceitos(daEmpresa: string[] | null, emailDoAtor: string): string[] {
  if (daEmpresa && daEmpresa.length) return daEmpresa
  const d = dominio(emailDoAtor)
  return d ? [d] : []
}

/** Mensagem do erro da API para a pessoa (sem eco do corpo: um 422 pode repetir o pedido). */
export function erroDoUsuario(e: unknown): 'exists' | 'password' | 'forbidden' | 'other' {
  if (!(e instanceof ApiError)) return 'other'
  if (e.status === 409) return 'exists'
  if (e.status === 422) return 'password'
  if (e.status === 403) return 'forbidden'
  return 'other'
}
